import { AutocompleteResult } from '../NetworkAutocomplete/NetworkAutocompleteOption'
import { ILegalEntityJSON, TLegalEntity } from './LegalEntitiesModel'

export function formatLabel(legalEntity: ILegalEntityJSON | TLegalEntity): string {
  if (!legalEntity) {
    return ''
  }
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- TODO: Fix template expression
  const eoriNumber = legalEntity.eoriNumber ? ` - ${legalEntity.eoriNumber}` : ''
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- TODO: Fix template expression
  const vatOrTax = legalEntity.hasVat ? ` - ${legalEntity.vatId}` : ` - ${legalEntity.taxId}`
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- TODO: Fix template expression
  return `${legalEntity.name}${eoriNumber}${vatOrTax}`
}

export function legalEntityToAutocompleteResult(legalEntity: ILegalEntityJSON): AutocompleteResult {
  return {
    value: legalEntity._id,
    label: formatLabel(legalEntity),
    data: { _id: 'label', entity: legalEntity },
  }
}
